module.exports = __webpack_public_path__ + "img/7_126.e700ada5.png";